module.exports = __webpack_public_path__ + "img/Zero2IPOGroup.cef237be.jpg";